import { Environments } from '../store/CheckoutContext';

export const setEnvironment = (environment: Environments, configuration: number, removeEnvironments: boolean) => {
  const scripts = document.querySelectorAll('script');
  scripts.forEach(el => {
    if (
      el?.textContent?.includes('JS-Widget') ||
      el?.textContent?.includes('UIWidget') ||
      el.id === 'JS-Widget' ||
      el.id === 'fc' ||
      el.id === 'UIWidget'
    ) {
      el.remove();
    }
  });

  document.querySelectorAll('#SEON_SDK_CONTAINER').forEach(el => el.remove());
  document.querySelectorAll('#seon-container-dis').forEach(el => el.remove());
  document.querySelectorAll('#ibody').forEach(el => el.remove());

  let senseUrl = 'https://fc-sensejs-staging.flex-charge.com/widget.js';
  let uiUrl = 'https://fc-ui-widget-staging.flex-charge.com/widget.js';

  switch (environment) {
    case 'development':
    case 'local':
      senseUrl = 'http://localhost:8081/widget.js';
      uiUrl = 'http://localhost:8080/widget.js';
      break;
    case 'staging':
      senseUrl = 'https://fc-sensejs-staging.flex-charge.com/widget.js';
      uiUrl = 'https://fc-ui-widget-staging.flex-charge.com/widget.js';
      break;
    case 'sandbox':
      senseUrl = 'https://sensejs-sandbox.flex-charge.com/widget.js';
      uiUrl = 'https://ui-widget-sandbox.flex-charge.com/widget.js';
      break;
    case 'production':
      senseUrl = 'https://sensejs.flex-charge.com/widget.js';
      uiUrl = 'https://ui-widget.flex-charge.com/widget.js';
      break;
  }

  const senseScript = document.createElement('script');
  const uiScript = document.createElement('script');

  let mid = localStorage.getItem('mid') || '';

  if (
    // @ts-ignore
    typeof window?.Cypress === 'undefined' &&
    // @ts-ignore
    typeof window.top?.Cypress === 'undefined' &&
    window?.top?.location?.search?.replace('mid=', '')
  ) {
    mid = window?.top?.location?.search
      ?.replace('?', '')
      ?.split('&')
      ?.find(el => el.includes('mid='))
      ?.replace('mid=', '') as string;
  }

  const sense = `
        (function (w,d,s,o,f,js,fjs) {
          w['JS-Widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
          js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
          js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
        }(window, document, 'script', 'fc', '${senseUrl}'));
        fc('init', '${mid}');
      `;

  const uiWidget = `
        (function (w,d,s,o,f,js,fjs) {
          w['Widget']=o;w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
          js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
          js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
        }(window, document, 'script', 'UIWidget', '${uiUrl}'));
        UIWidget('init', '${mid}');
      `;

  const senseTextNode = document.createTextNode(sense);
  const uiTextNode = document.createTextNode(uiWidget);

  senseScript.appendChild(senseTextNode);
  uiScript.appendChild(uiTextNode);

  document.head.appendChild(senseScript);
  document.head.appendChild(uiScript);
};
